import * as lodash from '../../utils/lodash';
import { registerBeforeRenderHook } from '../../core/hooks';
registerBeforeRenderHook(function (chart) {
    var barSeries = chart.getAllSeries().filter(function (series) { return series.type === 'bar' && series.visible(); });
    var stackList = [];
    if (barSeries.some(function (series) { return series.getOption().coord !== 'cartesian2d'; })) {
        return;
    }
    barSeries.forEach(function (barModel, index) {
        var currentBarOption = barModel.getOption();
        var stack = currentBarOption.stack, _a = currentBarOption.stacking, stacking = _a === void 0 ? 'normal' : _a;
        var isNullStack = lodash.isNull(stack) || lodash.isUndefined(stack);
        if (stacking === 'percent') {
            stack = "PERCENT_STACKING_" + (stack || 'default-stack');
        }
        else if (isNullStack) {
            stack = "NORMAL_STACK_" + index;
        }
        stackList.push(stack);
    });
    var uniqList = lodash.uniq(stackList);
    uniqList.forEach(function (stack) {
        var stackedBars = barSeries.filter(function (bar, index) { return stackList[index] === stack; });
        if (!stackedBars.some(function (bar) { return bar.getOption().minBarLength > 0; })) {
            return;
        }
        var points = stackedBars[0].getState().points;
        var _loop_1 = function (i) {
            var currentPoints = stackedBars.map(function (bar) { return bar.getState().points[i]; });
            var positivePoints = currentPoints.filter(function (point) { return point.value >= 0; });
            var negativePoints = currentPoints.filter(function (point) { return point.value < 0; });
            [positivePoints, negativePoints].forEach(function (stackPoints) { return stackPoints.reduce(function (delta, current) {
                var bar = stackedBars[currentPoints.indexOf(current)];
                var minBarLength = bar.getOption().minBarLength;
                var direction = current.direction, unknownShape = current.shape;
                var shape = unknownShape;
                var width = shape.width, height = shape.height;
                if ((direction === 'top' || direction === 'bottom')) {
                    if (height < minBarLength) {
                        delta += (minBarLength - height);
                        shape.height = minBarLength;
                    }
                    shape.y += (direction === 'top' ? -delta : delta);
                }
                if ((direction === 'left' || direction === 'right')) {
                    if (width < minBarLength) {
                        delta += (minBarLength - width);
                        shape.width = minBarLength;
                    }
                    shape.x += (direction === 'left' ? -delta : delta);
                }
                return delta;
            }, 0); });
        };
        for (var i = 0; i < points.length; i++) {
            _loop_1(i);
        }
    });
});
